import type { IPatient } from '../../../../../../common/interfaces/patient';
import type { IServiceGetOne } from '../../../../interfaces/serviceGetOne';
import { ToastType } from '../../../../../../common/enums/toastType';
import { translateKey } from '../../../../../translate';
import { checkUsesZorgmail } from '../../../../../utils/checkUsesZorgmail';
import { showServiceToast } from '../../../../../utils/showToast';

export async function diagnosticReportAddEditExaminationShowToast(
    saveType: 'draft' | 'final',
    service: IServiceGetOne,
    selectedEmploymentId: string | undefined,
    patient: IPatient
) {
    if (saveType === 'draft') {
        showServiceToast(
            ToastType.success,
            'toast.draftSuccess',
            service,
            'diagnosticReport',
            translateKey('toast.draftDefaultMessage')
        );
    } else {
        if (selectedEmploymentId && process && (await checkUsesZorgmail(service.id, patient, selectedEmploymentId))) {
            showServiceToast(
                ToastType.success,
                'toast.requestConfirmedAndSentToHis',
                service,
                'diagnosticReport',
                translateKey('toast.confirmedRequestDefaultMessageAndSentToHis')
            );
        } else {
            showServiceToast(
                ToastType.success,
                'toast.requestConfirmed',
                service,
                'diagnosticReport',
                translateKey('toast.confirmedRequestDefaultMessage')
            );
        }
    }
}
